import { animate, stagger } from "motion";

import { RdFileTree } from "./components/FileTree.js";
import { RdOverlay } from "./components/Overlay Dialog/Overlay.js";
import { MonacoEditorLit } from "./components/Editor/editor.js";
import { RdSideBar } from "./components/TabMenus/SideBar/SideBar.js";
import { RdDropDownPanel } from "./components/DropdownPanel/DropDownPanel.js";
import { RDGenericDropdown } from "./components/DropdownPanel/GenericDropdown.js";
import { RdPageLayout } from "./components/Dashboard/Layout/PageLayout.js";
import { TopBar } from "./components/Dashboard/TopBar/TopBar.js";
import { RDPropsetContainer } from "./components/Propsets/Container/PropContainer.js";
import { propUnit } from "./components/Propsets/Inputs/UnitNumber.js";
import { propNumber } from "./components/Propsets/Inputs/Number.js";
import { propText } from "./components/Propsets/Inputs/Text.js";
import { propRange } from "./components/Propsets/Inputs/Range.js";
import { propOption } from "./components/Propsets/Inputs/Option.js";
import { propSelection } from "./components/Propsets/Inputs/Selection.js";
import { propTextArea } from "./components/Propsets/Inputs/TextArea.js";
import { Preloader } from "./components/Preloader/Preloader.js";
import { propImage } from "./components/Propsets/Inputs/Image.js";
import { ColorPickerPanel } from "./components/DropdownPanel/ColorPickerPanel.js";
import { propColor } from "./components/Propsets/Inputs/Color.js";
import { propButton } from "./components/Propsets/Inputs/Button.js";
import { propAlert } from "./components/Propsets/Inputs/Alert.js";
import { propTags } from "./components/Propsets/Inputs/Tags.js";
import { propIcon } from "./components/Propsets/Inputs/Icon.ts";
import { RdFormatToolbar } from "./components/Toolbars/FormatToolbar.ts";

import { BaseControl } from "./components/Shared/Controls/Base.ts";
import { RDTextBox } from "./components/Shared/Controls/TextBox.ts";
import { propAccordion } from "./components/Propsets/Inputs/Accordion.ts";
import { RDBoxModelProp } from "./components/Propsets/Inputs/ModelBox.ts";
import { RDFontManager } from "./components/Shared/Controls/FontManager.js";
import { RDModal } from "./components/Shared/Controls/Modal.js";
import { RDAlertBox } from "./components/Shared/Controls/AlertBox.js";
import { DomNavigator } from "./components/Shared/Controls/Navigator.js";
import { RDEditorGuides } from "./components/Shared/Controls/EditorGuide.js";
import { RDBreadcrumbs } from "./components/Shared/Controls/CanvasBreadcrumbs.js";
import { RDDeviceSelector } from "./components/Dashboard/TopBar/DeviceSelector.js";
import { RDCheckbox } from "./components/Shared/Controls/Checkbox.js";
import { RDTabs, RDTabPanel, RDEditorTabs, RDEditorTab } from "./components/Shared/TabbedControl.js";
import { RDHighlighter } from "./components/Highlighters/Highlighter.js";
import { RDComponentBrowser } from "./components/Blocks/ComponentBrowser.ts";

export default {
  animate,
  stagger,
  propNumber,
  RdFileTree,
  RdOverlay,
  MonacoEditorLit,
  RDDeviceSelector,
  RdSideBar,
  RdDropDownPanel,
  RDGenericDropdown,
  RdPageLayout,
  TopBar,
  RDPropsetContainer,
  propUnit,
  propText,
  propRange,
  propOption,
  propSelection,
  propTextArea,
  Preloader,
  propImage,
  ColorPickerPanel,
  propColor,
  propButton,
  propAlert,
  propTags,
  propIcon,
  RdFormatToolbar,
  BaseControl,
  RDTextBox,
  propAccordion,
  RDBoxModelProp,
  RDFontManager,
  RDModal,
  RDAlertBox,
  DomNavigator,
  RDEditorGuides,
  RDBreadcrumbs,
  RDCheckbox,
  RDTabs,
  RDTabPanel,
  RDEditorTabs,
  RDEditorTab,
  RDHighlighter,
  RDComponentBrowser,
};
